import React from 'react';
import { SmButton } from '@smiles/smiles-react-design-system';

type TProps = React.HTMLProps<HTMLButtonElement> & {
  text: string;
  isOutlined?: boolean;
  isPill?: boolean;
  variant?: 'primary' | 'club';
};

export function Button({
  text,
  className,
  onClick,
  isOutlined,
  isPill,
  variant,
}: TProps) {
  return (
    <SmButton
      className={className}
      text={text}
      onClick={onClick}
      isOutlined={isOutlined}
      isPill={isPill}
      variant={variant}
    />
  );
}
